export const SuperRealTypesConfig = {
  logError: (error: Error) => {
    console.log(error);
  },
};
